import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    CheckboxField,
    Button,
    Loader
} from '@aws-amplify/ui-react';
import { useEffect, useState } from 'react';
import EditResult from './edit-result';

const ResultsCard = ({ items,
    selected,
    isLoading,
    onAddNewResult,
    onUpdateResult,
    onDeleteCheckedResults,
    onLoadMoreClicked
}) => {
    const [groupedResults, setGroupedResults] = useState([])
    const [modalShow, setModalShow] = useState(false);
    const [selectedResult, setSelectedResult] = useState(null)
    const [checkedResults, setCheckedResults] = useState(new Set([]))
    const [hasMore, setHasMore] = useState(false)

    useEffect(() => {
        if (items[selected?.id]?.items) {
            const grouped = Object.groupBy(items[selected?.id]?.items, (item) => {
                const date = new Date(item.timestamp);
                // Returns YYYY-MM-DD format which sorts correctly
                return date.toISOString().split('T')[0];
            })
            setCheckedResults(new Set([]))
            setGroupedResults(grouped)
        }
        setHasMore(items[selected?.id]?.hasMore ?? false)
    }, [items, selected])

    return (
        <div>

            <EditResult
                show={modalShow}
                selecteditem={selectedResult}
                onHide={(e) => {
                    setModalShow(false)
                    if (e) {
                        e.exercise = selected.id
                        e.user = selected.user
                        if (e.id) {
                            onUpdateResult(e)
                        } else {
                            e.id = crypto.randomUUID()
                            onAddNewResult(e)
                        }
                    }
                }}></EditResult>

            {!isLoading &&
                <div>
                    <Table highlightOnHover={true}>
                        <TableHead>
                            <TableRow>
                                <TableCell className='text-align-start'>
                                    <div>
                                        <Button className='me-1' variation="primary" onClick={() => {
                                            setSelectedResult(null)
                                            setModalShow(true)
                                        }}>Create</Button>


                                        <Button
                                            isDisabled={checkedResults.size === 0}
                                            colorTheme='error'
                                            className='mb-1'
                                            onClick={() => {
                                                onDeleteCheckedResults(checkedResults)
                                            }}>Delete</Button>
                                    </div>
                                </TableCell>
                                <TableCell as="th" >
                                    Weight
                                </TableCell>
                                <TableCell as="th" >
                                    Reps
                                </TableCell>
                                <TableCell as="th" >
                                    Comment
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        {groupedResults && Object.keys(groupedResults).sort((a, b) => b.localeCompare(a)).map((date, groupIndex) => {
                            return (
                                <TableBody key={date}>
                                    <TableRow className='text-align-start no-color-change'>
                                        <TableCell colSpan={4}><b>{date}</b></TableCell>
                                    </TableRow>
                                    {groupedResults[date]?.map((item, itemIndex) => (
                                        <TableRow
                                            onClick={() => {
                                                setSelectedResult(item)
                                                setModalShow(true)
                                            }}
                                            key={itemIndex}
                                            style={{ cursor: 'pointer' }}>
                                            <TableCell>
                                                <div style={{ width: 'fit-content' }} onClick={(e) => e.stopPropagation()}>
                                                    <CheckboxField
                                                        checked={checkedResults.has(item.id)}
                                                        className='m-1'
                                                        onClick={(e) => {
                                                            setCheckedResults(prevSet => {
                                                                const newSet = new Set(prevSet);
                                                                if (e.target.checked) {
                                                                    newSet.add(item.id);
                                                                } else {
                                                                    newSet.delete(item.id);
                                                                }
                                                                return newSet;
                                                            });
                                                        }} />
                                                </div>
                                            </TableCell>
                                            <TableCell>{item?.result || 0}</TableCell>
                                            <TableCell>{item?.repetitions || 0}</TableCell>
                                            <TableCell>{item?.comment || ""}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            );
                        })}

                    </Table>
                    {hasMore &&
                        <div className='d-flex justify-content-center mt-2'>
                            <Button onClick={() => { onLoadMoreClicked() }}>
                                Load more
                            </Button>
                        </div>
                    }
                </div>
            }
            {isLoading &&
                <div>
                    <Loader />
                    <span>Loading..</span>
                </div>
            }
        </div>
    )
}
export default ResultsCard